module.exports = __webpack_public_path__ + "static/media/meeting-table.4ce0226e.svg";